import * as UIToolkit from '../../UIToolkit/index';
import * as CubeTree from '../../cubeTree/index';
import FrontCubeData from '../../frontCubeData/index';
import { updateLayerWithoutLayout, updateLayerHasLayout } from '../../update/updateLayer';
import { updateCodiSystem } from '../../update/updateCodiSystem';
import { doneAsync } from '../../update/done';
import { __walk__ } from './db';
import { layout } from './layout';

function groupLayout(links: LinkedListInstance[]): void {
    links.forEach((link: LinkedListInstance, index: number): void => {
        layerLinkLayout(link);
    });
}

function layerLinkLayout(link: LinkedListInstance): void {
    let layoutParams: FreeObjMap = {};
    let layers: CubeId[] = link.valueList();

    if (layers.length) {
        let layerLayoutType: LayoutType = UIToolkit.layoutType(layers[0]);

        if (layerLayoutType === '---|||') {
            layers = layers.reverse();
        }
    }

    let linkCubes: CubeId[] = CubeTree.findCubesChildren(layers);

    // 如果链接层板是空的，就不用触发布局算法
    if (linkCubes.length) {
        layers.forEach((layer: CubeId): void => {
            layout(layer);
        });
    }
    updateLayers(layers);
}

function updateLayers(layers: CubeId[]): void {
    updateLayerWithoutLayout(layers);
    updateCodiSystem();
    doneAsync();
}

function updateLayersWithLayout(layers: CubeId[]): void {
    updateLayerHasLayout(layers);
    updateCodiSystem();
    doneAsync();
}

export {
    groupLayout,
    updateLayers,
    updateLayersWithLayout
};
